export default {
      id: "maintenance_table-usage",
      viewBox: "0 0 33 29",
      url: __webpack_public_path__ + "img/icons.svg#maintenance_table",
      toString: function () {
        return this.url;
      }
    }